import React from "react";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TrackTraceFilters, TrackTraceMapPayload } from "../../trackTrace/types";

interface Props {
    payload?: TrackTraceMapPayload | null;
    filters: TrackTraceFilters;
    onChange: (filters: TrackTraceFilters) => void;
    onApply: () => void;
}

const AssetFilterPanel: React.FC<Props> = ({ payload, filters, onChange, onApply }) => {
    const { i18n } = useTranslation();
    const t = (key: string, options?: object) => (i18n.t as unknown as (key: string, options?: object) => string)(key, options);
    const assetTypes = payload?.summary.asset_type_counts || [];
    const zones = payload?.zones || [];

    const set = (key: keyof TrackTraceFilters, value: string) => onChange({ ...filters, [key]: value || undefined });

    return (
        <div className="asset-filter-panel">
            <Form.Select value={filters.asset_type_id || ''} onChange={(event) => set('asset_type_id', event.target.value)} aria-label={t('track_trace.filters.asset_type_filter')}>
                <option value="">{t('track_trace.filters.all_types')}</option>
                {assetTypes.map((type) => <option key={String(type.asset_type_id)} value={String(type.asset_type_id)}>{type.asset_type_name}</option>)}
            </Form.Select>
            <Form.Select value={filters.status || ''} onChange={(event) => set('status', event.target.value)} aria-label={t('track_trace.filters.status_filter')}>
                <option value="">{t('track_trace.filters.all_statuses')}</option>
                {Object.keys(payload?.summary.status_counts || {}).map((status) => (
                    <option key={status} value={status}>
                        {t(`track_trace.statuses.${status}`, { defaultValue: status.replaceAll('_', ' ') })}
                    </option>
                ))}
            </Form.Select>
            <Form.Select value={filters.freshness || ''} onChange={(event) => set('freshness', event.target.value)} aria-label={t('track_trace.filters.freshness_filter')}>
                <option value="">{t('track_trace.filters.any_freshness')}</option>
                <option value="recent">{t('track_trace.freshness.recent')}</option>
                <option value="stale">{t('track_trace.freshness.stale')}</option>
                <option value="old">{t('track_trace.freshness.old')}</option>
                <option value="unknown">{t('track_trace.freshness.unknown')}</option>
            </Form.Select>
            <Form.Select value={filters.zone_id || ''} onChange={(event) => set('zone_id', event.target.value)} aria-label={t('track_trace.filters.zone_filter')}>
                <option value="">{t('track_trace.filters.all_zones')}</option>
                {zones.map((zone) => <option key={zone.id} value={zone.id}>{zone.name}</option>)}
            </Form.Select>
            <Button variant="outline-primary" onClick={onApply}>{t('track_trace.actions.apply')}</Button>
        </div>
    );
};

export default AssetFilterPanel;
